import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';

import { EventTypes } from '../types';
import { EventAdapter } from './EventAdapter';

export class EmailVerificationEventAdapter extends EventAdapter {
  protected intercomEventKey = 'email_verified';

  constructor() {
    super();
    this.eventData = {};
  }

  protected amplitudeEventFunction = function sendEventData() {
    sendTeacherAmplitudeEvent(EventTypes.EmailVerified);
  };
}
